<template>
    <div>
        <p-input :label="label" :model-value="addressString"
                    :disabled="disabled" readonly v-if="!textArea">
            <template v-slot:append>
                <b-button @click="showEdit">
                    <i class="fas fa-edit"></i>
                </b-button>
            </template>
        </p-input>
        <p-text-area :model-value="addressString"
                    :disabled="disabled" readonly v-else>
            <template v-slot:editButton>
                <div><strong>{{label}}</strong>
                    <p-button 
                        :disabled="disabled" 
                        :is-busy="isBusy" 
                        @click="showEdit" 
                        no-border class="ps-2 pb-2 d-inline">
                            <i class="fas fa-edit"></i>
                    </p-button>
                </div>
            </template>
        </p-text-area>
        <p-modal :name="name" :label="label" :ref="name" @ok="saveUpdate" :button-busy="isBusy">
            <p-form ref="addressForm">
                <p-address
                    v-model="editAddress"
                    v-bind="$attrs"
                    full-width
                    :disabled="disabled"
                    :sameAsAddressName="sameAsAddressName"
                    :sameAsAddress="sameAsAddress"
                >

                    <template v-for="(_, name) in $slots" :key="name" v-slot:[name]="slotData">
                        <slot :name="name" v-bind="slotData" />
                    </template>
                </p-address>
            </p-form>
        </p-modal>
    </div>
</template>
<script>
import baseInputs from '@/components/mixins/BaseInputs';
import Addresses from '@/components/mixins/Addresses.js';
export default {
    inheritAttrs: false,
    emits: ['updateShipping', 'update:modelValue', 'input'],
    name: 'p-address-input',
    mixins: [baseInputs, Addresses],
    props: {
        // value prop now comes from modelValue via BaseInputs mixin
        disabled: {
            type: Boolean,
            default: false
        },        
        textArea: {
            type: Boolean,
            default: false
        },
        isBusy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        value() { return this.modelValue; },
    },
    data() {
        return {
            editAddress: {}
        };
    },

    methods: {
        showEdit() {
            this.editAddress = { ...this.value };
            this.$refs[this.name].show();
        },
        async saveUpdate(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (!(await this.$refs.addressForm.validate())) {
                return;
            }            
            this.handleInput(this.editAddress);
            this.$refs[this.name].hide();
            this.$emit('updateShipping');
        }
    }
};
</script>

<style scoped lang="scss">
@import "@/styles/app/common/variables.scss";
:deep(.form-control[readonly]:not([disabled])) {
    background-color: var(--m-input-bg, white);
}
:deep(textarea ) {
    resize:none
}

</style>
